import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { EDownloadReportType } from 'core/model/enums';
import type { IDownloadsState } from './downloads.types';

export const SLICE_NAMESPACE = 'downloads-uploads/downloads';

export const DOWNLOADS_INITIAL_STATE: IDownloadsState = {
  filters: {
    reportType: EDownloadReportType.USER_MASTER,
  },
  list: {
    loading: false,
    downloads: [],
    pagination: { ...DEFAULT_PAGINATION },
  },
  form: {
    loading: false,
    success: false,
  },
};
